import { Avatar as MUIAvatar, AvatarProps } from '@mui/material';

export { type AvatarProps } from '@mui/material';

export function Avatar(props: AvatarProps) {
  return <MUIAvatar {...props} />;
}
